



















import { Component, Mixins, Prop } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { centros } from "@/shared/dtos/centros";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import centrosModule from "@/store/modules/centros-module";
import { UtilsString } from "@/utils/utils-string";
import grupo_centroModule from "@/store/modules/grupo_centro-module";

@Component({
  components: {},
})
export default class CentrosFormulario extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: centros = new centros();

  public async OnCreated() {
    this.ShowLoading();

    if (this.getparamId().HayParametro) {
      await centrosModule.getcentros(this.getparamId().Parametro);
      this.item_pantalla = centrosModule.centros;
    }

    await grupo_centroModule.getgrupo_centros();

    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;

    this.HideLoading();
  }

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.AddFormItemDataDefaultString(
      this.item_pantalla.nombre,
      "Nombre",
      "nombre",
      100
    )
      .isRequired()
      .Dimesiones(12, 4, 2);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.codigo_sucursal,
      "Codigo Sucursal",
      "codigo_sucursal",
      datatypes.maxlength
    )
      .isRequired()
      .Dimesiones(12, 4, 1);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.latitud,
      "Latitud",
      "latitud",
      60
    )
      .isRequired()
      .Dimesiones(12, 4, 2);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.longitud,
      "Longitud",
      "longitud",
      datatypes.maxlength
    )
      .isRequired()
      .Dimesiones(12, 4, 2);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.direccion,
      "Direccion",
      "direccion",
      datatypes.maxlength
    )
      .isRequired()
      .Dimesiones(12, 4, 5);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_grupo,
      "Grupo Centro",
      "id_grupo"
    )
      .CreateComboSingleCodigoDescripcionNames(
        grupo_centroModule.grupo_centros,
        "nombre",
        "id"
      )
      .Dimesiones(12, 6, 4);
  }

  public Insertar(object: centros) {
    centrosModule.guardarcentros(object).then(() => {
      this.AllSaveOk();
    });
  }

  public Actualizar(object: centros) {
    centrosModule.modificarcentros(object).then(() => {
      this.AllSaveOk(); //guardo correctamente y me cierro
    });
  }
}
